// import components
import { Tooltip } from '@mui/material';
import {
  ControlledAutoComplete,
  ControlledCheckbox
} from 'components/shared/ControlledFields';
import ControlledTimeField from 'components/shared/ControlledFields/ControlledTimeField';
import { StyledBoxFlexCenter } from 'components/shared/Box/Box.styles';
import { Icon } from '@sdb/planning-ui';

// import hooks
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// import types
import { AIMatchSettingsType } from 'components/types';
import { FC } from 'react';

// import utils
import { getTimeSlotOptions } from '../utils';
import { AIMatchSettingsProps } from './AIMatchSettings.types';

export const AIMatchSettings: FC<AIMatchSettingsProps> = ({
  type,
  isLoading
}: AIMatchSettingsProps) => {
  const timeSlots = getTimeSlotOptions() || [];
  const { control } = useFormContext();
  const { t } = useTranslation('common', { keyPrefix: 'aiMatchSettings' });

  switch (type) {
    case AIMatchSettingsType.TIMES:
      return (
        <StyledBoxFlexCenter>
          <ControlledAutoComplete
            name={AIMatchSettingsType.TIMES}
            label={t('times')}
            control={control}
            disabled={isLoading}
            optionLabelProp="label"
            idProperty="value"
            options={timeSlots}
            variant="outlined"
            multiple
          />
          <Tooltip title={t('timesTooltip')} arrow>
            <Icon type="circle-info" color="primary" />
          </Tooltip>
        </StyledBoxFlexCenter>
      );

    case AIMatchSettingsType.BEFORE_START_LIMIT:
      return (
        <StyledBoxFlexCenter>
          <ControlledTimeField
            fullWidth
            control={control}
            label={t('beforeStartLimit')}
            name={AIMatchSettingsType.BEFORE_START_LIMIT}
            variant="outlined"
            size="small"
          />
          <Tooltip title={t('beforeStartLimitTooltip')} arrow>
            <Icon type="circle-info" color="primary" />
          </Tooltip>
        </StyledBoxFlexCenter>
      );
    case AIMatchSettingsType.FLEX_ENABLED:
      return (
        <ControlledCheckbox
          name={AIMatchSettingsType.FLEX_ENABLED}
          label={t('flexEnabled')}
          control={control}
          disabled={isLoading}
        />
      );
    case AIMatchSettingsType.NON_FLEX_ENABLED:
      return (
        <ControlledCheckbox
          name={AIMatchSettingsType.NON_FLEX_ENABLED}
          label={t('nonFlexEnabled')}
          control={control}
          disabled={isLoading}
        />
      );
    default:
      return null;
  }
};
